<div [class]="ui.logoWrapper">
  <a routerLink="/" data-testid="nav-logo">
    <img alt="" class="{{ui.logoImg}}" src="{{logo()}}" />
  </a>
  <button type="button" (click)="sidebarToggle()" [class]="ui.toggle" aria-label="Collapse sidebar">
    <app-feather-icons [icon]="'grid'" class="align-middle" data-testid="nav-collapse-toggle"></app-feather-icons>
  </button>
</div>
<button type="button" (click)="sidebarToggle()" [class]="ui.logoIconWrapper" aria-label="Expand sidebar">
  <img alt="" class="{{ui.logoIconImg}}" src="{{icon()}}" />
</button>
<nav>
  <div id="sidebar-menu">
    <ul [class]="ui.links">
      @for (menuItem of menuItems(); track $index) {
      <li [class]="ui.item" [ngClass]="{active: menuItem.active}">
        @if (menuItem.badgeType && menuItem.badgeValue) {
        <label class="badge badge-{{menuItem.badgeType}} {{ui.badge}}">{{menuItem.badgeValue}}</label>
        }

        <!-- Sub -->
        @if (menuItem.type === 'sub') {
        <button
          type="button"
          (click)="toggledNavActive(menuItem)"
          [ngClass]="{active: menuItem.active}"
          [class]="ui.link + ' ' + ui.buttonReset"
          [attr.aria-expanded]="menuItem.active"
          data-testid="nav-menu-link"
        >
          <app-feather-icons [icon]="menuItem.icon" [class]="ui.icon"></app-feather-icons>
          <span [class]="ui.label">{{menuItem.title | translate}}</span>
          @if (menuItem.children) {
          <div [class]="ui.accordion">
            <i
              class="fa fa-angle-{{menuItem.active ? 'down' : 'right'}} float-right ml-[.3em] {{ui.accordionIcon}}"
            ></i>
          </div>
          }
        </button>
        } @else if (menuItem.type === 'demo-link') {
        <!-- Demo App Link -->
        <a [class]="ui.link" class="demo-link" data-testid="nav-menu-link">
          <app-feather-icons [icon]="menuItem.icon" [class]="ui.icon"></app-feather-icons>
          <span [class]="ui.label">{{menuItem.title | translate}}</span>
          <div class="upgrade-icon collapsed:hidden!">
            <i class="fa fa-diamond float-right ml-1" appTooltip="{{ 'SIDEBAR.UPGRADE_TOOLTIP' | translate }}"> </i>
          </div>
        </a>
        } @else if (menuItem.type === 'disabled-link') {
        <!-- Disabled App Link -->
        <a [class]="ui.link" class="disabled-link" data-testid="nav-menu-link">
          <app-feather-icons
            [icon]="menuItem.icon"
            [class]="ui.icon"
            class="cursor-not-allowed opacity-50"
          ></app-feather-icons>
          <span [class]="ui.label">{{menuItem.title | translate}}</span>
          @if (menuItem.children) {
          <div [class]="ui.accordion">
            <i
              class="fa fa-angle-{{menuItem.active ? 'down' : 'right'}} float-right ml-[.3em] {{ui.accordionIcon}}"
            ></i>
          </div>
          }
        </a>
        } @else if (menuItem.type === 'link') {
        <!-- Link -->
        <a
          (click)="toggledNavActive(menuItem)"
          [ngClass]="{active: menuItem.active}"
          [routerLink]="!menuItem.type ? null : [menuItem.path]"
          [class]="ui.link"
          data-testid="nav-menu-link"
        >
          <app-feather-icons [icon]="menuItem.icon" [class]="ui.icon"></app-feather-icons>
          <span [class]="ui.label">{{menuItem.title | translate}}</span>
          @if (menuItem.children) {
          <div [class]="ui.accordion">
            <i
              class="fa fa-angle-{{menuItem.active ? 'down' : 'right'}} float-right ml-[.3em] {{ui.accordionIcon}}"
            ></i>
          </div>
          }
        </a>
        } @else if (menuItem.type === 'extLink') {
        <!-- External Link -->
        <a
          [ngClass]="{active: menuItem.active}"
          [class]="ui.link"
          data-testid="nav-menu-link"
          href="{{ !menuItem.type ? null : menuItem.path }}"
        >
          <app-feather-icons [icon]="menuItem.icon" [class]="ui.icon"></app-feather-icons>
          <span [class]="ui.label">{{menuItem.title | translate}}</span>
          @if (menuItem.children) {
          <div [class]="ui.accordion">
            <i
              class="fa fa-angle-{{menuItem.active ? 'down' : 'right'}} float-right ml-[.3em] {{ui.accordionIcon}}"
            ></i>
          </div>
          }
        </a>
        } @else if (menuItem.type === 'extTabLink') {
        <!-- External Tab Link -->
        <a
          [ngClass]="{active: menuItem.active}"
          [class]="ui.link"
          data-testid="nav-menu-link"
          href="{{ !menuItem.type ? null : menuItem.path }}"
          target="_blank"
        >
          <app-feather-icons [icon]="menuItem.icon" [class]="ui.icon"></app-feather-icons>
          <span [class]="ui.label">{{menuItem.title }}</span>
          @if (menuItem.children) {
          <div [class]="ui.accordion">
            <i
              class="fa fa-angle-{{menuItem.active ? 'down' : 'right'}} float-right ml-[.3em] {{ui.accordionIcon}}"
            ></i>
          </div>
          }
        </a>
        }

        <!-- 2nd Level Menu -->
        @if (menuItem.children) {
        <ul [class]="ui.subMenu" [style.display]="menuItem.active ? 'block' : 'none'">
          @for (childrenItem of menuItem.children; track $index) {
          <li [ngClass]="{active: childrenItem.active}">
            <!-- Sub -->
            @if (childrenItem.type === 'sub') {
            <button
              type="button"
              (click)="toggledNavActive(childrenItem)"
              [class]="ui.subLink + ' ' + ui.buttonReset"
              [attr.aria-expanded]="childrenItem.active"
            >
              <span [class]="ui.subLabel"> {{childrenItem.title | translate}}</span>
              @if (childrenItem.children) {
              <div [class]="ui.subAccordion">
                <i
                  class="fa fa-angle-{{childrenItem.active ? 'down' : 'right'}} float-right ml-[.3em] {{ui.subAccordionIcon}}"
                ></i>
              </div>
              }
            </button>
            } @else if (childrenItem.type === 'link') {
            <!-- Link -->
            <a
              [routerLinkActiveOptions]="{exact: true}"
              [routerLink]="!childrenItem.type ? null : [childrenItem.path]"
              (click)="toggledNavActive(childrenItem)"
              [ngClass]="{active: childrenItem.active}"
              [class]="ui.subLink"
              routerLinkActive="active"
            >
              <span [class]="ui.subLabel">{{childrenItem.title | translate}}</span>
              @if (childrenItem.children) {
              <i class="fa fa-angle-down float-right ml-[.3em]"></i>
              }
            </a>
            } @else if (childrenItem.type === 'extLink') {
            <!-- External Link -->
            <a
              [routerLinkActiveOptions]="{exact: true}"
              [class]="ui.subLink"
              href="{{ !childrenItem.type ? null : childrenItem.path }}"
              routerLinkActive="active"
            >
              <span [class]="ui.subLabel">{{childrenItem.title | translate}}</span>
              @if (childrenItem.children) {
              <i class="fa fa-angle-down float-right ml-[.3em]"></i>
              }
            </a>
            } @else if (childrenItem.type === 'extTabLink') {
            <!-- External Tab Link -->
            <a [class]="ui.subLink" href="{{ !childrenItem.type ? null : childrenItem.path }}" target="_blank">
              <span [class]="ui.subLabel">{{childrenItem.title | translate}}</span>
              @if (childrenItem.children) {
              <i class="fa fa-angle-down float-right ml-[.3em]"></i>
              }
            </a>
            } @else if (childrenItem.type === 'disabled-link') {
            <!-- Disabled Link -->
            <span [class]="ui.subLink" class="disabled-link" data-testid="nav-disabled-link">
              <span [class]="ui.subLabel">{{childrenItem.title | translate}}</span>
            </span>
            }

            <!-- 3rd Level Menu -->
            @if (childrenItem.children) {
            <ul [class]="ui.childMenu" [style.display]="childrenItem.active ? 'block' : 'none'">
              @for (childrenSubItem of childrenItem.children; track $index) {
              <li [ngClass]="{active: childrenSubItem.active}">
                <!-- Link -->
                @if (childrenSubItem.type === 'link') {
                <a
                  [routerLinkActiveOptions]="{exact: true}"
                  [routerLink]="!childrenSubItem.type ? null : [childrenSubItem.path]"
                  [class]="ui.childLink"
                  routerLinkActive="active"
                >
                  <span [class]="ui.subLabel"> {{childrenSubItem.title | translate}}</span>
                </a>
                } @else if (childrenSubItem.type === 'extLink') {
                <!-- External Link -->
                <a
                  [routerLinkActiveOptions]="{exact: true}"
                  href="{{ !childrenSubItem.type ? null : childrenSubItem.path }}"
                  [class]="ui.childLink"
                  routerLinkActive="active"
                >
                  <span [class]="ui.subLabel">{{childrenSubItem.title | translate}}</span>
                </a>
                } @else if (childrenSubItem.type === 'extTabLink') {
                <!-- External Tab Link -->
                <a
                  href="{{ !childrenSubItem.type ? null : childrenSubItem.path }}"
                  [class]="ui.childLink"
                  target="_blank"
                >
                  <span [class]="ui.subLabel">{{childrenSubItem.title | translate}}</span>
                </a>
                } @else if (childrenSubItem.type === 'disabled-link') {
                <!-- Disabled Link -->
                <a href="javascript:void(0)" [class]="ui.childLink" class="disabled-link">
                  <span [class]="ui.subLabel">{{childrenSubItem.title | translate}}</span>
                </a>
                }
              </li>
              }
            </ul>
            }
          </li>
          }
        </ul>
        }
      </li>
      }
    </ul>
  </div>
  @if (newTheme()) {
  <app-account-sidebar
    class="fixed bottom-0 left-0 z-1 block max-w-[280px]"
    [class]="collapseSidebar() ? 'w-[90px]' : 'w-[280px]'"
    [collapseSidebar]="collapseSidebar()"
  ></app-account-sidebar>
  }
</nav>
